module.exports = __webpack_public_path__ + "static/media/transporter-3.92f33116.svg";